import axios from 'axios'

import {
  type CoreBookingDocument,
  type DocusealTemplateResponse,
} from '@flecto/types'

import { deserialize } from '../../../services/deserialize'

/**
 * Create Docuseal template from PDF via local API.
 *
 * @endpoint POST /api/docuseal/templates-from-pdf
 * @scope shared
 */
export async function createDocumentTemplateFromPdf(
  document: CoreBookingDocument,
  external_id: string,
  application_key: string
): Promise<DocusealTemplateResponse> {
  const response = await axios
    .create()
    .post('/api/docuseal/templates-from-pdf', {
      name: document.filename_base,
      category: document.category,
      external_id,
      application_key,
      document: {
        name: document.filename_base,
        file: document.url,
      },
    })

  const { data } = deserialize(response)

  return data
}
